import { Form, Wrapper } from 'ui';
import { ChatInput, type ChatInputFormValues } from '../chat-input';
import { useSendChatMessage } from '../hooks';

type ChatRoomFormValues = ChatInputFormValues;

type P = {
  chatroomId: string;
};

const ChatFooter = ({ chatroomId }: P) => {
  const [form] = Form.useForm<ChatRoomFormValues>();
  const { sendChatMessage } = useSendChatMessage();

  const initialValues: Partial<ChatRoomFormValues> = { attachments: [], message: '' };

  const handleFinish = ({ attachments, message: messageText }: ChatRoomFormValues) => {
    sendChatMessage({ attachments, chatroomId, messageText });
    form.setFieldsValue(initialValues);
  };

  return (
    <Wrapper paddingHorizontal="ms" paddingVertical={[0, 'ms']}>
      <Form<ChatRoomFormValues> form={form} initialValues={initialValues} onFinish={handleFinish}>
        <ChatInput<ChatRoomFormValues> />
      </Form>
    </Wrapper>
  );
};

export default ChatFooter;
